import styled from "@emotion/styled";
import { FC, useState } from "react";

import { Add } from "@livechat/design-system-icons";
import { ActionMenu, Button, IActionMenuOption, Icon } from "@livechat/design-system-react-components";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IVariableSelectParams } from "components/rich-editor/formatted-text-editor";
import { RichTextVariables } from "components/rich-editor/plugins/constants";
import { StackingContextLevel } from "styles/stacking-context-level";

import { ContentType } from "../constants";

import { pickerItems } from "./pickerItems";

interface IProps {
  onSelect: (payload: IVariableSelectParams) => void;
  variablesPluginOptions?: RichTextVariables[];
  insertCleanVariables?: boolean;
}

export const VariableSelect: FC<IProps> = ({ onSelect, variablesPluginOptions, insertCleanVariables }) => {
  const [parametersVisible, setParametersVisible] = useState(false);

  const handleVariableSelect = (item: string): void => {
    const parameter = pickerItems(ContentType.HTML, insertCleanVariables).find(i => i.key === item);

    if (!parameter) {
      return;
    }

    onSelect({
      label: parameter.props.name.props.children.props.children[1].props.children,
      content: parameter.props.value,
    });
    setParametersVisible(false);
  };

  const options: IActionMenuOption[] = pickerItems(ContentType.HTML)
    .filter(item => variablesPluginOptions?.includes(item.key as RichTextVariables))
    .map(item => ({
      key: item.key,
      element: item.props.name,
      onClick: () => handleVariableSelect(item.key),
    }));

  return (
    <Container>
      <ActionMenu
        visible={parametersVisible}
        options={options}
        onClose={() => setParametersVisible(false)}
        triggerRenderer={
          <Button
            data-testid="variable-select"
            icon={<Icon source={Add} />}
            iconPosition="left"
            onClick={() => setParametersVisible(true)}
            kind="plain"
          >
            Add Variable
          </Button>
        }
      />
    </Container>
  );
};

const Container = styled.div`
  z-index: ${StackingContextLevel.ContentOverlayDropdown};
  display: flex;
  justify-content: flex-end;
  margin-left: auto;

  p {
    margin: 0;
  }
`;
